import * as React from 'react';
import type { SupportedWixLocales } from 'wix-design-systems-locale-utils';

export interface TrendIndicatorProps {
  dataHook?: string;
  className?: string;
  value: number;
  inverted?: boolean;
  locale?: SupportedWixLocales;
}

export default class TrendIndicator extends React.PureComponent<TrendIndicatorProps> {}
